import React, {Component} from "react";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import ExtAppService from "../api/services/ExtAppService";

import './CalendarListView.css';
import AppointmentType from "../api/AppointmentType";
import Appointment from "../api/Appointment";
import PendingView from "./pending/PendingView";
import User from "../api/User";
import moment from "moment";


const clientContactFormatter = (data) => {
	const contact = User.GetContact(data.value);
	return (contact || {}).value || 'N/A';
}

/*
it was to be descending order by date first (edited)
there was to be the action column so they could approve or edit from this screen.
pending were to show first
followed by the rest of them by date
highlights for pending and clients not in the system
 */

export default class CalendarListView extends Component {

	/**
	 *
	 * @returns Appointment[]
	 */
	get appointments(){
		return this.props.appointments.filter( app => app.userId === this.props.doctorId).map((app) => {
			return new Appointment(app);
		});
	}

	get bcAppointments() {
		const weekStart = moment(this.props.date).day(0);
		const weekEnd = moment(this.props.date).day(6);
		return this.props.bcApps.filter( app => {
			const start = moment(app.startDate);
			return (app.biopedUserId === this.props.doctorId) && (start.isBetween(weekStart, weekEnd, undefined, '[]'));
		});
	}

	onGridReady = (params) => {
		params.api.sizeColumnsToFit();
		window.addEventListener('resize', function () {
			setTimeout(function () {
				params.api.sizeColumnsToFit();
			});
		});
	}

	onRowRowSelected = (event) => {
		const app = event.node.data;
		if(this.props.onAppointmentSelect){
			this.props.onAppointmentSelect(app);
		}
	}


	render(){
		console.log('CalendarListView Appointments:', this.appointments);
		const hasBcApps = (this.bcAppointments || []).length;
		return(
			<div className={'calendar-list-view ag-theme-alpine'}>
				{ hasBcApps? <PendingView bcApps={this.bcAppointments} />: null}
				<AgGridReact
					rowData={this.appointments}
					rowSelection="single"
					defaultColDef={{resizable: true}}
					animateRows={true}
					onGridReady={this.onGridReady}
					onRowSelected={this.onRowRowSelected}
				>
					<AgGridColumn field="$dateDuration" headerName="Date/Time" sortable={true}/>
					<AgGridColumn field="client.fullName" headerName="Name" sortable={true}/>
					<AgGridColumn field="appointmentType.name" headerName="Service" sortable={true}/>
					<AgGridColumn field="client" headerName="Contact" sortable={true} valueFormatter={clientContactFormatter} />
					<AgGridColumn field="status" headerName="Status" sortable={true}/>

				</AgGridReact>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/views/CalendarListView.jsx